/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".dummy_1540fcab{background:blue}\n"}]);
export const dummy = "dummy_1540fcab";